import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const QuestionText = styled(Typography)({
  fontSize: '16px',
  color: '#353F48',
})
